import BaseService from '../baseServices';
import REST from '../../configs/rest';

function putCarWash({ body }) {
  return BaseService.put(REST.CAR_WASH_BASE, body);
}

function putCarWashId({ body, id }) {
  return BaseService.put(REST.CAR_WASH_ID(id), body);
}

function getCarWashBase() {
  return BaseService.get(REST.CAR_WASH_BASE);
}

function getCarWash({ params }) {
  let q = `start=${params?.start}&end=${params?.end}`;
  if (params?.holiday) {
    const parsedHoliday = params?.holiday
      .map((item) => {
        return `"${item}"`;
      })
      .join(',');
    q = `holiday=[${parsedHoliday}]&${q}`;
  }
  return BaseService.get(`${REST.CAR_WASH}?${q}`);
}

export default {
  getCarWash,
  getCarWashBase,
  putCarWash,
  putCarWashId,
};
